<div class="button-delivery" [ngClass]="{'selected': state === 'selected'}" (click)="onClick()">
    <div class="delivery-icon">
        <img class="w-full h-full" [src]="(iconPath | async)" alt="Food {{ text }}"/>
    </div>
    <div class="delivery-text" [ngClass]="{'selected': state === 'selected'}">{{ text }} </div>
</div>